import { jwtDecode } from 'jwt-decode';
interface MyJwtPayload {
  sub: string;
  name: string;
  exp: number;
  roles: string[];
}

export const isTokenRoles = (token: string | null) => {
  if (token) {
    const decodedToken: MyJwtPayload = jwtDecode(token ? token : '');
    return (
        decodedToken.roles.includes('SUPER_ADMIN') ||
        decodedToken.roles.includes('APP_ACCOUNT') ||
        decodedToken.roles.includes('SWM_SENDER')
    );
  }
};

export const superAdminValidation = (token: string | null) => {
  if (token) {
    const decodedToken: any = jwtDecode(token ? token : '');
    const roles = decodedToken.roles as string[];
    return roles.includes('SUPER_ADMIN');
  }
};

export const appAccountValidation = (token: string | null) => {
  if (token) {
    const decodedToken: any = jwtDecode(token ? token : '');
    const roles = decodedToken.roles as string[];
    return roles.includes('APP_ACCOUNT');
  }
};

export const swmAccountValidation = (token: string | null) => {
  if (token) {
    const decodedToken: any = jwtDecode(token ? token : '');
    const roles = decodedToken.roles as string[];
    return roles.includes('SWM_SENDER');
  }
};

export const isTokenExpired = (token: string | null) => {
  if (token) {
    const decodedToken: MyJwtPayload = jwtDecode(token ? token : '');
    const currentTime = Date.now() / 1000;
    const isTokenExpired =
      (decodedToken.exp ? decodedToken.exp : 0) < currentTime;
    const isTokenValid =
      token === undefined || '' || null ? false : isTokenExpired;
    return isTokenValid;
  }
};
